import script from "./SubmitRequestCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitRequestCard.vue?vue&type=script&setup=true&lang=js"

import "./SubmitRequestCard.vue?vue&type=style&index=0&id=21102ce1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21102ce1"]])

export default __exports__